import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

import { Observable, of } from 'rxjs';
import { map, tap, shareReplay } from 'rxjs/operators';

import { CssVarsService } from './css-vars.service';
import { ThemeService } from './theme.service';

import { CssVarsTheme, defaults } from './branding';

import { default as ServerMap } from './themes/server.map.json';
import { default as Themes } from './themes/themes.json';

@Injectable({
   providedIn: 'root'
})
export class BrandingService {
   url = 'assets/themes';

   cached = {};

   private renderer: Renderer2;

   constructor(
      private factory: RendererFactory2,

      private cssVarsService: CssVarsService,
      private themeService: ThemeService,
   ) {
      this.renderer = this.factory.createRenderer( null, null );
      this.cssVarsService.setTheme( defaults );

      this.load();
   }

   load(): void {
      this.serverMap().subscribe( serverMap => {
         const regex = `(${Object.keys( serverMap ).join( '|' )})`;
         const matches = new RegExp( regex ).exec( window.location.hostname );
         const host = matches?.[0];
         const themeConst = serverMap?.[host];

         if ( themeConst ) {
            this.setTheme( themeConst );
         }
      });
   }

   setTheme( brand: string ) {
      this.getTheme( brand ).subscribe(( theme: CssVarsTheme ) => {
         this.cssVarsService.setTheme( theme );

         // FavIcon
         let link = document.querySelector("link[rel~='icon']");
         if ( !link ) {
            link = this.renderer.createElement( 'link' );
            link['rel'] = 'icon';
            this.renderer.appendChild( document.head, link );
         }
         link['href'] = theme.favIcon;

         this.themeService.themeChange$.next( theme );
      });
   }

   getTheme( brand: string ): Observable<CssVarsTheme> {
      return of( Themes[brand] ).pipe(
         map( theme => ({ ...defaults, ...theme })),
         tap( theme => this.cached[brand] = of( theme )),
         shareReplay(),
      );
   }

   getAllThemes(): Observable<CssVarsTheme[]> {
      return of( Themes ).pipe(
         map( themes => Object.values( themes ) as CssVarsTheme[]),
         shareReplay(),
      );
   }

   serverMap() {
      return of( ServerMap );
   }
}
